import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { OrgDto, SourcingEventDto } from "../../../../../../autogen/bff-api";
import type { ExclusionGroundsSummaryData } from "../summary/QualificationSection";
import { computeEspdRequirement } from "../../utils/computeEspdRequirement";
import { valueJudgedAgainstThresholds } from "../../utils/thresholdValue";
import { EspdPreviewDelI } from "./EspdPreviewDelI";
import { EspdPreviewDelII } from "./EspdPreviewDelII";
import { EspdPreviewDelIII } from "./EspdPreviewDelIII";
import { EspdPreviewDelIV } from "./EspdPreviewDelIV";
import { EspdPreviewDelV } from "./EspdPreviewDelV";
import { EspdPreviewDelVI } from "./EspdPreviewDelVI";
import { EspdThresholdBanner } from "./EspdThresholdBanner";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  event: SourcingEventDto;
  organization: OrgDto;
  exclusionGroundsSummary: ExclusionGroundsSummaryData;
}

export const EspdPreviewModal = ({ isOpen, onClose, event, organization, exclusionGroundsSummary }: Props) => {
  const { t } = useTranslation();
  const publicContext = event.eventContext.type === "Public" ? event.eventContext : null;
  const judged = valueJudgedAgainstThresholds(publicContext);
  const requirement = computeEspdRequirement(
    publicContext?.regulation ?? null,
    publicContext?.foaPart ?? null,
    judged.value,
    judged.judgedBy,
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("Preview ESPD form")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <EspdThresholdBanner requirement={requirement} mb="4" />
          <EspdPreviewDelI event={event} organization={organization} />
          <EspdPreviewDelII />
          <EspdPreviewDelIII summary={exclusionGroundsSummary} />
          <EspdPreviewDelIV criteria={event.eventData.selectionCriteria ?? []} />
          <EspdPreviewDelV procedureType={publicContext?.procedureType ?? null} />
          <EspdPreviewDelVI />
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" onClick={onClose}>
            {t("Close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
